import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const MPTCoursePage: React.FC = () => {
  const courseData = {
    title: "M.P.T. (Master of Physiotherapy)",
    shortName: "M.P.T",
    duration: "2 years",
    description: "Postgraduate program in physiotherapy specializing in advanced therapeutic techniques and clinical rehabilitation",
    overview: "Master of Physiotherapy (M.P.T) is a 2-year postgraduate program designed for B.P.T graduates seeking specialization in specific areas of physiotherapy. The program combines advanced theoretical knowledge with hands-on clinical training in specialized domains such as Orthopedics, Neurology, Sports Physiotherapy, and others. Graduates develop expertise in complex patient management and rehabilitation techniques.",
    eligibility: [
      "Bachelor of Physiotherapy (B.P.T) degree",
      "Minimum 55% marks in B.P.T",
      "Valid GATE score or university entrance exam",
      "Teaching experience or clinical experience may be required",
      "Age limit as per university norms"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Advanced Orthopedic Physiotherapy",
          "Advanced Neurological Physiotherapy",
          "Research Methodology",
          "Evidence-Based Practice",
          "Advanced Manual Therapy",
          "Biomechanics and Kinesiology",
          "Clinical Practice - Specialization I",
          "Seminar and Journal Club"
        ]
      },
      {
        year: 2,
        subjects: [
          "Advanced Clinical Practice",
          "Dissertation/Research Project",
          "Specialized Techniques Training",
          "Patient Management & Case Studies",
          "Clinical Internship",
          "Professional Ethics & Healthcare Management",
          "Advanced Assessment Techniques",
          "Thesis Presentation and Defense"
        ]
      }
    ],

    specializations: [
      "Orthopedic Physiotherapy",
      "Neurological Physiotherapy",
      "Sports Physiotherapy",
      "Cardio-Pulmonary Physiotherapy",
      "Pediatric Physiotherapy",
      "Geriatric Physiotherapy",
      "Community Physiotherapy",
      "Occupational Health"
    ],

    careerProspects: {
      roles: [
        "Specialist Physiotherapist",
        "Clinical Physiotherapy Specialist",
        "Sports Medicine Physiotherapist",
        "Rehabilitation Consultant",
        "Physiotherapy Educator/Lecturer",
        "Research Associate/Scholar",
        "Healthcare Administrator",
        "Occupational Health Specialist",
        "International Physiotherapy Consultant",
        "Clinical Research Coordinator"
      ],
      industries: [
        "Tertiary Care Hospitals",
        "Sports Medicine Centers",
        "Rehabilitation Facilities",
        "Sports Organizations",
        "Medical Research Institutions",
        "Armed Forces Medical Services",
        "Corporate Wellness Programs",
        "Educational Institutions",
        "International Healthcare Organizations",
        "Government Health Services"
      ],
      averageSalary: "₹6-10 LPA (Fresher), ₹20-50 LPA (Experienced/Private Practice)",
      topRecruiters: [
        "Apollo Hospitals",
        "Max Healthcare",
        "Fortis Hospitals",
        "Indian Railways",
        "Armed Forces Medical Services",
        "Sports Authority of India",
        "AIIMS",
        "Medical Research Centers",
        "International Sports Organizations",
        "Premium Wellness Centers"
      ]
    },

    admissionProcess: [
      "Valid GATE/University entrance exam score",
      "Merit-based selection from qualified candidates",
      "University-conducted entrance examination",
      "Interview and counseling round",
      "Merit list preparation",
      "Document verification",
      "Medical fitness certificate",
      "Final admission confirmation"
    ],

    topColleges: [
      {
        name: "Manipal College of Physiotherapy",
        location: "Manipal, Karnataka",
        fees: "₹2-2.5 LPA",
        ranking: "NIRF Ranking: 15 (Health Sciences)"
      },
      {
        name: "JSS College of Physiotherapy",
        location: "Mysore, Karnataka",
        fees: "₹1.5-2 LPA",
        ranking: "Accredited by APTA"
      },
      {
        name: "DIPSAR (Delhi Institute of Paramedical and Skill Development)",
        location: "Delhi",
        fees: "₹50,000-1 LPA",
        ranking: "Government Institute"
      },
      {
        name: "Jamia Hamdard University",
        location: "Delhi",
        fees: "₹1-1.5 LPA",
        ranking: "AICTE Approved"
      }
    ],

    skills: [
      "Advanced Patient Assessment",
      "Specialized Treatment Planning",
      "Advanced Manual Therapy Techniques",
      "Research and Critical Appraisal",
      "Clinical Decision Making",
      "Patient Education and Counseling",
      "Teaching and Mentoring",
      "Clinical Leadership",
      "Evidence-Based Practice Implementation",
      "Professional Communication",
      "Advanced Diagnostic Reasoning",
      "Healthcare Quality Management"
    ],

    futureScope: "Growing demand for specialist physiotherapists in premium healthcare settings, increasing opportunities in sports physiotherapy and international clinics, expansion of rehabilitation services in corporate wellness, opportunities in research and academics, and scope for private specialized practice.",

    faqs: [
      {
        question: "What is the difference between B.P.T and M.P.T?",
        answer: "B.P.T is an undergraduate 4.5-year program providing basic physiotherapy knowledge. M.P.T is a postgraduate 2-year program that provides specialized advanced knowledge in specific areas like Orthopedics, Neurology, or Sports Physiotherapy."
      },
      {
        question: "Do I need to work after B.P.T before pursuing M.P.T?",
        answer: "No, it's not mandatory. You can pursue M.P.T immediately after B.P.T. However, some universities prefer 1-2 years of clinical experience. Work experience strengthens your application and research understanding."
      },
      {
        question: "What specialization should I choose in M.P.T?",
        answer: "Choose based on your interest and career goals. Orthopedic and Sports Physiotherapy have more job opportunities. Neurology is excellent for research. Select based on your strengths and desired career path."
      },
      {
        question: "Can I pursue M.P.T from abroad?",
        answer: "Yes, many universities in USA, Canada, Australia, and UK offer advanced physiotherapy programs. Indian M.P.T is widely recognized and respected internationally."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default MPTCoursePage;
